/**
 * Allows elements to reveal hidden elements.
 *
 * Example usage:
 * Apples, Oranges, <a class="reveal" data-target="#hidden">...</a><div id="hidden" class="truncated" hidden>Pears</div>
 */
export default function initTruncatedComponents() {
    for (const el of document.querySelectorAll(".reveal")) {
        console.log(el)

        if (!("target" in el.dataset)) {
            continue;
        }

        const hidden_elements_sel = el.dataset["target"];
        const hidden_elements = document.querySelectorAll(hidden_elements_sel);

        console.log(hidden_elements)

        el.addEventListener("click", () => {
            el.remove();
            for (const hidden_el of hidden_elements) {
                // HACK: to make it seem like the truncated elements are part of some container element
                //  move the children out of the container element.
                hidden_el.outerHTML = hidden_el.innerHTML;
            }
        })
    }
}